import { render, staticRenderFns } from "./pressrelease.vue?vue&type=template&id=657a2795&scoped=true&"
import script from "./pressrelease.vue?vue&type=script&lang=js&"
export * from "./pressrelease.vue?vue&type=script&lang=js&"
import style0 from "./pressrelease.vue?vue&type=style&index=0&id=657a2795&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657a2795",
  null
  
)

export default component.exports